import { render } from "./Skeleton.vue?vue&type=template&id=77474118"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script